module.exports = __webpack_public_path__ + "static/media/AOArsz.734ea17e.mp4";